<template>
  <transition name="modal">
    <div
      v-show="show"
      class="drawer-wrap fixed pin-t pin-l w-full h-full"
      @click.self="() => $emit('close')">
      <nav
        class="drawer drawer--visible">
        <div class="flex align-center  pr-4 pl-4  my-4 justify-between">
          <slot name="header">Default</slot>
          <SmartIcon
            class="icon-close cursor-pointer absolute"
            name="close"
            @click="() => $emit('close')"
            :size="2"/>
        </div>
        <slot name="headerSecondary" />
        <slot/>
      </nav>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'SmartDrawer',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show(isShowing) {
      if (isShowing) {
        document.documentElement.style.overflow = 'hidden';
      } else {
        document.documentElement.style.overflow = '';
      }
    }
  },
  beforeDestroy() {
    document.documentElement.style.overflow = '';
  }
};
</script>

<style lang="scss" scoped>
  .modal {
    &-enter,
    &-leave-to {
      opacity: 0;

    }

    &-enter-active {
      .drawer {
        animation-name: modalIn;
      }
    }

    &-leave-active {
      .drawer {
        animation-name: modalOut;
      }
    }

    &-enter-active,
    &-leave-active {
      transition: opacity $transition-sm-medium $transition-easing-default;
      .drawer {
        animation-duration: $transition-sm-medium;
        animation-fill-mode: both;
      }
    }
  }

  @keyframes modalIn {
    from {
      transform: translate3d(100%, 0, 0);
    }
    to {
      transform: translate3d(0,0,0);
    }
  }

  @keyframes modalOut {
    from {
      transform: translate3d(0,0,0);
    }
    to {
      transform: translate3d(100%, 0, 0);
    }
  }


  .drawer-wrap {
    z-index: 999999;
    background-color: rgba(0,0,0,0.4);
  }

.icon-close {
  top: 1.5rem;
  right: 1.5rem;
}
.icon-close:hover {
  color: $color-brand-secondary;
}

nav.drawer {
  position: absolute;
  top: 0px;
  right: -20rem;
  bottom: 0px;
  left: auto;
  height: auto;
  width: 20rem;
  background: $color-ui-white;
  right: 0px;
  box-shadow: 0 4px 24px rgba($color-ui-black, $opacity-low-half);
  overflow-x: auto;
}
  .drawer.drawer--visible {
    width: 40rem;
    overflow: auto;
  }
</style>
